__turbopack_context__.v({
  "className": "inter_3a5f5640-module__ftrHua__className",
});
